import React, {useEffect} from 'react';
import {Flex} from "antd";
import IntlMessage from "../../../../../components/IntlMessage/IntlMessage";
import {useDispatch, useSelector} from "react-redux";
import {changeCurrentPage} from "../../../../../store/slices/tableController/MEditorsListTableController";
import MyTable from "../../../../../components/Table/MyTable";
import {getAllMEditorsPageable} from "../../../../../store/slices/MEditorsListSlice";

const MEditorsList = () => {
    const dispatch = useDispatch();
    const {editors, isLoading, hasMore, error} = useSelector(state => state.mEditorsList);
    const {currentPage, pageSize} = useSelector(state => state.mEditorsListTableController);

    useEffect(() => {
        dispatch(getAllMEditorsPageable({
            page: currentPage,
            limit: pageSize
        }));
    }, []);

    const fetchData = async (params) => {
        return dispatch(getAllMEditorsPageable({
            ...params
        }));
    }

    const saveCurrentPageSettings = (page, pageSize) => {
        dispatch(changeCurrentPage({page: page, pageSize: pageSize}));
    };

    const columns = [
        {
            title: <span style={{fontWeight: 600}}><IntlMessage id={'fullName'}/> / <IntlMessage
                id={'username'}/></span>,
            render: (_, record) => (
                <p>{record.profile ? (record.profile.fullName) : record.username}</p>
            ),
        },
        {
            title: <span style={{fontWeight: 600}}><IntlMessage id={'email'}/></span>,
            render: (_, record) => (
                <p>{record.profile.email}</p>
            ),
        },
    ];

    return (
        <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} vertical gap={20}>
            <MyTable
                isLoading={isLoading}
                dataSource={editors}
                columns={columns}
                fetchData={fetchData}
                saveCurrentPage={saveCurrentPageSettings}
                initialPage={currentPage}
                initialPageSize={pageSize}
                hasMore={hasMore}
            />
        </Flex>
    );
};

export default MEditorsList;